import { DynamicObject } from '../../commonTypes';

const initialLanguageObject: DynamicObject = {};

export const gtm: any = {
  Client_ID: 'N/A',
  ContentLang: 'N/A',
  DateTimeStamp: '',
  DisplayLang: 'N/A',
  G_ID: '',
  userCountry: '',
  pageName: '',
  TimeHHMMSS: '',
  UserType: 'guest',
  event: '',
  languageObject: initialLanguageObject,
  defferedEvents: [],
  mixpanelUserType: 'N/A',
  mixpanelUniqueId: 'N/A',
  mixpaneldisplayLanguage: 'N/A',
  mixpanelContentLanguage: 'N/A',
  VILPartnerName: 'N/A',
  Dekey: 'N/A',

  queueGTMEvents(gtmEvent: any) {
    if (
      gtm.mixpanelUserType === 'N/A' ||
      gtm.mixpanelUniqueId === 'N/A' ||
      gtm.mixpaneldisplayLanguage === 'N/A' ||
      gtm.mixpanelContentLanguage === 'N/A' ||
      gtm.VILPartnerName === '' ||
      gtm.Dekey === ''
    ) {
      gtm.defferedEvents.push({ gtmEvent });
    } else if (typeof window !== 'undefined') {
      window.dataLayer.push(gtmEvent);
    }
  },

  couponCodeAppliedEventGTM(code: string) {
    try {
      const gtmEvent = {
        event: 'Coupon Code Applied Successfully',
        couponCodeText: code
      };
      if (typeof window !== 'undefined') {
        window.dataLayer.push(gtmEvent);
      } else {
        gtm.defferedEvents.push({ gtmEvent });
      }
    } catch (error) {
      console.error('couponCodeAppliedEventGTM', error);
    }
  },

  packSelectedEventGTM(packDetails: DynamicObject) {
    try {
      const durationInDays: DynamicObject = {
        'CMS_PLAN_30-DAYS_TEXT': 30,
        'CMS_PLAN_90-DAYS_TEXT': 90,
        'CMS_PLAN_180-DAYS_TEXT': 180,
        'CMS_PLAN_365-DAYS_TEXT': 365
      };
      const gtmEvent = {
        event: 'Selected Pack Details',
        packName: packDetails?.title,
        packDuration: durationInDays[packDetails?.duration],
        packPrice: packDetails?.actual_price
      };
      if (typeof window !== 'undefined') {
        window.dataLayer.push(gtmEvent);
      } else {
        gtm.defferedEvents.push({ gtmEvent });
      }
    } catch (error) {
      console.error('packSelectedEventGTM', error);
    }
  },

  otpVerificationSuccessfulEventGTM() {
    try {
      const gtmEvent = {
        event: 'LoginSuccess'
      };
      if (typeof window !== 'undefined') {
        window.dataLayer.push(gtmEvent);
      } else {
        gtm.defferedEvents.push({ gtmEvent });
      }
    } catch (error) {
      console.error('otpVerificationSuccessfulEventGTM', error);
    }
  },

  triggerDefferedEvent(
    uniqueID: any,
    userType: any,
    displayLanguage: any,
    contentLanguage: any,
    partnerName: any,
    dekey: any
  ) {
    if (
      userType !== 'N/A' &&
      uniqueID !== 'N/A' &&
      displayLanguage !== 'N/A' &&
      contentLanguage !== 'N/A' &&
      partnerName !== undefined &&
      dekey !== undefined
    ) {
      gtm.mixpanelUserType = userType;
      gtm.mixpanelUniqueId = uniqueID;
      gtm.mixpaneldisplayLanguage = displayLanguage;
      gtm.mixpanelContentLanguage = contentLanguage;
      gtm.VILPartnerName = partnerName;
      gtm.Dekey = dekey;
      gtm.defferedEvents.forEach((event: any) => {
        if (event.gtmEvent.event === 'PageView') {
          event.gtmEvent.UserType = userType;
          event.gtmEvent.G_ID = uniqueID;
          event.gtmEvent.DisplayLang = displayLanguage;
          event.gtmEvent.ContentLang = contentLanguage;
          event.gtmEvent.partner_name =
            partnerName === '' || partnerName === 'N/A'
              ? undefined
              : partnerName;
          event.gtmEvent.dekey = dekey;
        }
        window.dataLayer.push(event.gtmEvent);
      });
      gtm.defferedEvents = [];
    }
  },

  getVilPartnerName() {
    if (this.VILPartnerName === 'N/A' || this.VILPartnerName === '') {
      return undefined;
    }
    return this.VILPartnerName;
  },

  // Login Out Event
  logOutEventGTM(partnerName: string) {
    // const VILPartner = this.getVilPartnerName();
    window.dataLayer = window.dataLayer || [];
    if (typeof window !== 'undefined') {
      // all Login Out details
      this.sendDetails = {
        event: 'LogOut',
        partner_name:
          partnerName === 'samsungmygalaxyapp' ? partnerName : 'VILPartner',
        dekey: this.Dekey
      };
      gtm.queueGTMEvents(this.sendDetails);
    }
  }
};
